export default {
  namespaced: true,
  
  state: {
    // 代理概览
    overview: {
      settledCommission: 0,
      pendingCommission: 0,
      pendingUserCount: 0,
      invitedUserCount: 0
    },
    
    // 邀请的用户
    invitedUsers: [],
    
    
    // 代理利润
    agentProfit: [],
  },
  
  getters: {
    overview: state => state.overview,
    invitedUsers: state => state.invitedUsers,
    agentProfit: state => state.agentProfit,
    
    // 计算属性
    totalCommission: state => state.overview.settledCommission + state.overview.pendingCommission
  },
  
  mutations: {
    SET_OVERVIEW(state, overview) {
      state.overview = overview
    },
    
    SET_INVITED_USERS(state, users) {
      state.invitedUsers = users
    },
    
    SET_AGENT_PROFIT(state, profit) {
      state.agentProfit = profit
    },
  },
  
  actions: {
    async fetchAgentOverview({ commit }) {
      try {
        commit('SET_LOADING', true, { root: true })
        // 使用API模块
        const agentApi = await import('@/api/agent').then(m => m.default)
        const data = await agentApi.getAgentOverview()
        
        if (data.code !== 200) {
          throw new Error(data.message || '获取代理概览失败')
        }
        
        commit('SET_OVERVIEW', data.data.overview)
        
        return data
      } catch (error) {
        throw error
      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    },
    
    async fetchInvitedUsers({ commit }, params = {}) {
      try {
        commit('SET_LOADING', true, { root: true })
        // 使用API模块
        const agentApi = await import('@/api/agent').then(m => m.default)
        const data = await agentApi.getInvitedUsers(params)
        
        if (data.code !== 200) {
          throw new Error(data.message || '获取邀请用户失败')
        }
        
        commit('SET_INVITED_USERS', data.data.users)
        
      // 使用pagination模块处理分页
        commit('pagination/SET_PAGINATION', {
          current: data.data.page,
          limit: data.data.limit,
          total: data.data.total
        }, { root: true })
        
        
        return data
      } catch (error) {
        throw error
      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    },
    
    async fetchAgentProfit({ commit }, params = {}) {
      try {
        commit('SET_LOADING', true, { root: true })
        // 使用API模块
        const agentApi = await import('@/api/agent').then(m => m.default)
        const data = await agentApi.getAgentProfit(params)
        
        if (data.code !== 200) {
          throw new Error(data.message || '获取代理利润失败')
        }
        
        commit('SET_AGENT_PROFIT', data.data.profit)
        
        // 使用pagination模块处理分页
        commit('pagination/SET_PAGINATION', {
          current: data.data.page,
          limit: data.data.limit,
          total: data.data.total
        }, { root: true })
        
        return data
      } catch (error) {
        throw error
      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    },
    
    async allowAgent({ commit, dispatch }, userId) {
      try {
        commit('SET_LOADING', true, { root: true })
        // 使用API模块
        const agentApi = await import('@/api/agent').then(m => m.default)
        const data = await agentApi.allowAgent(userId)
        
        if (data.code !== 200) {
          throw new Error(data.message || '设置代理失败')
        }
        
        return data
      } catch (error) {
        throw error
      } finally {
        commit('SET_LOADING', false, { root: true })
      }
    },
  }
}
